export const getMontoTotalReclamado = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoReclamado,
    0
  );
};

export const getMontoTotalArs = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoARS,
    0
  );
};

export const getMontoTotalAfiliado = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => {
      const monto = procedimiento.montoAsegurado ?? procedimiento.montoAfiliado ?? 0;
      return acumulador + monto;
    },
    0
  );
};

export const getMontoField = (procedimiento) => {
  return procedimiento.montoAsegurado ?? procedimiento.montoAfiliado ?? 0;
};